/*
 * Filename: field-details-model.helper.ts
 */
export class FieldDetailsModelHelper {

    /**
     * @param {string[]} fieldKeys
     * @param {*} RuleObject
     * @param {*} fields
     * @returns
     * @memberof FieldDetailsModelHelper
     */
    public setAppliedRuleObject(fieldKeys: string[], RuleObject: any, fields: any) {
        fieldKeys.forEach((fieldKey: any) => {
            if (RuleObject.hasOwnProperty(fieldKey)) {
                if (fields[fieldKey].hasOwnProperty('appliedRuleObject')) {
                    const fieldObject = { ...fields[fieldKey] };
                    fieldObject.appliedRuleObject = RuleObject[fieldKey];
                    fields[fieldKey] = fieldObject;
                } else {
                    let fieldObject = { ...fields[fieldKey] };
                    fieldObject = { ...fieldObject, appliedRuleObject: RuleObject[fieldKey] };
                    fields[fieldKey] = fieldObject;
                }

            }
        });
        return fields;
    }

    /**
     * @param {*} modelField
     * @param {*} fields
     * @returns
     * @memberof FieldDetailsModelHelper
     */
    public setAppliedRuleHelper(modelField:any ,fields:any ){
        const fieldKeys = Object.keys(modelField);
            fieldKeys.forEach((fieldKey: any) => {
                const fieldObject = { ...fields[fieldKey] };
                if (fieldObject && fieldObject.hasOwnProperty('appliedRuleObject')) {
                    delete fieldObject.appliedRuleObject;
                }
                fields[fieldKey] = fieldObject;
            });
            return fields;
        }
    
}

export const fieldDetailsHelper = new FieldDetailsModelHelper();